export default __webpack_public_path__ + "static/media/about1.09943403.png";